export const UserEdit = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="14" cy="9" r="6" stroke="currentColor" stroke-width="2"/>
<path d="M5 30V25C5 21.6863 7.68629 19 11 19H19.476" stroke="currentColor" stroke-width="2"/>
<path d="M21 29H18V26L26.9292 17.0708C26.9683 17.0317 27.0317 17.0317 27.0707 17.0708L29.9343 19.9385C29.9734 19.9775 29.9733 20.0409 29.9342 20.0799L21 29Z" stroke="currentColor" stroke-width="2"/>
<path d="M27 23L24 20" stroke="currentColor" stroke-width="2"/>
</svg>`;
